import type { TFunction } from 'i18next'
import type { z } from 'zod'

import { generateTextFromJsonString } from '@mntn-dev/editor/utils'

import type { RefinementEffect } from './types.ts'

export type IsFormattedTextLengthValidOptions = {
  min?: number
  max?: number
}

export const isFormattedTextLengthValid = (
  t: TFunction<'validation'>,
  fieldName: string,
  { min, max }: IsFormattedTextLengthValidOptions
) =>
  ({
    type: 'refinement',
    refinement: (input: string, ctx: z.RefinementCtx) => {
      const text = generateTextFromJsonString(input).trim()

      if (min && text.length < min) {
        ctx.addIssue({
          code: 'custom',
          message:
            min === 1
              ? t('refinements.editor.required', { field: fieldName })
              : t('refinements.editor.min', { min, count: min }),
        })
      }

      if (max && text.length > max) {
        ctx.addIssue({
          code: 'custom',
          message: t('refinements.editor.max', { max, count: max }),
        })
      }
    },
  }) satisfies RefinementEffect<string>
